module.exports = __webpack_public_path__ + "src/assets/img/touch.ea5dc6ec.png";